
export const list = (values: any) => {


    // const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + values.id

    // let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/owner/remittance/check/log`;
    let url = `https://192.168.0.202/fuelphp/public/contraction/rest/list/shreact.json`
    // let url = `http://localhost:5000/api/v1/owner/remittance/check/logs`;
    // alert(JSON.stringify(values))
    // values.date1 = moment(values.date1).format("dddd, MMMM Do YYYY, h:mm:ss a"); 
    // values.date2 = '2020/8/31'
    // alert(JSON.stringify(values))
    // values.bk_no = 4857
    return fetch(url, {
        method: 'post',

        // headers: { 'Content-type': 'application/json; charset=UTF-8' }
        body: JSON.stringify(values),
        // headers: { 'Content-type': 'application/json' }
    })
        .then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));


}

